import type { FC } from 'react';
import Link from 'next/link';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';

export interface ImageLinkProps extends LocalImageProps {
    href?: string;
    className?: string;
}
const ImageLink: FC<ImageLinkProps> = ({ href, className, ...imageProps }) =>
    href ? (
        <Link
            href={href}
            target="_blank"
            className={className}
        >
            <LocalImage {...imageProps} />
        </Link>
    ) : (
        <LocalImage
            className={className}
            {...imageProps}
        />
    );

export default ImageLink;
